import { CSSProperties } from "react";

import { makeStyles } from "tss-react/mui";

interface IParams {
    width: CSSProperties["width"];
    anchor?: "right" | "bottom";
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    paper: {
        display: "block",
        backgroundColor: theme.palette.common.white,
        height: "100%",
        width: props.width ?? 490,
        borderTopLeftRadius: props.anchor === "bottom" ? theme.shape.borderRadius : 0,
        borderTopRightRadius: props.anchor === "bottom" ? theme.shape.borderRadius : 0,
        [theme.breakpoints.down("md")]: {
            height: "90%",
        },
    },
    backdrop: {
        backgroundColor: "rgba(0, 0, 0, 0.15)",
    },
    closeButton: {
        position: "fixed",
        right: 0,
        color: theme.palette.primary.main,
        padding: theme.spacing(1),
        margin: theme.spacing(1),
        zIndex: 1,
        "& svg": {
            fontSize: "2rem",
        },
    },
}));
